<div class="py-2 px-2">
    <app-confirm-popup [triggerModal]="showModal" *ngIf="showModal" [title]="'Delete'"
        [message]="'Are you sure you want to delete this record ?'" [confirmText]="'Delete'" [cancelText]="'Cancel'"
        (confirm)="onDeleteConfirm()" (cancel)="onDeleteCancel()"></app-confirm-popup>
    <h5 class="mb-2">{{gridTitle}}</h5>
    <nz-table *ngIf="!reOrderTable && !nestedTable" [nzTableLayout]="'auto'" [ngStyle]="{'height':tableHeight}"
        #basicTable [nzData]="dataSet" [nzNoResult]="'No Records Found!'" [(nzPageSize)]="pageSize"
        [(nzPageIndex)]="pageIndex" [nzShowPagination]="true" [nzHideOnSinglePage]="true"
        [nzFrontPagination]="frontPagination" [nzShowSizeChanger]="true" [nzShowQuickJumper]="true"
        (nzCurrentPageDataChange)="onCurrentPageDataChange($event)" [nzScroll]="{ y: 'calc(100vh - 276px)' }"
        #sortTable>
        <thead>
            <tr>
                <ng-container *ngFor="let col of columns">
                    @if(col?.type == 'checkbox' && !col.header){
                    <th nzWidth="50px" [ngClass]="gridStyle == 'white' ? 'grid-style' : ''" [nzChecked]="checked"
                        [nzIndeterminate]="indeterminate" nzLabel="Select all"
                        (nzCheckedChange)="onAllChecked(col.field, $event)">
                    </th>
                    }
                    @else{
                    <th [nzWidth]="col?.width ? col.width : 'auto'"
                        [ngStyle]="{'text-align': (col?.type== 'checkbox' && col.header) ? 'center' : 'left' }"
                        [nzSortFn]="col.compare" [ngClass]="gridStyle == 'white' ? 'grid-style' : ''">{{col.header}}
                    </th>
                    }
                </ng-container>
            </tr>
        </thead>
        <tbody>
            @for(data of basicTable.data; track $index; let i = $index){
            <tr>
                <ng-container *ngFor="let col of columns">
                    <td nzWidth="50px" *ngIf="col?.type == 'checkbox'" [nzChecked]="setOfCheckedId.has(data[col.field])"
                        [nzDisabled]="data.disabled" [nzLabel]="data[col.field]"
                        (nzCheckedChange)="onItemChecked(col.field, data[col.field], $event)">
                    </td>
                    <td *ngIf="col?.type == 'toggle'">
                        @if(col?.editable){
                        <nz-switch [disabled]="!data.edit" (ngModelChange)="toggledData(data,$event)"
                            [(ngModel)]="data[col.field]"></nz-switch>
                        }
                        @else{
                        <nz-switch [disabled]="data.pageEdit" (ngModelChange)="toggledData(data,$event)"
                            [(ngModel)]="data[col.field]"></nz-switch>
                        }
                    </td>
                    <td *ngIf="col?.type == 'select'">
                        @if(data?.edit && col?.editable){
                        <nz-select style="width: 30%;" [(ngModel)]="data[col.field]">
                            @for(value of dropdownList; track value){
                            <nz-option [nzValue]="value" [nzLabel]="value">
                            </nz-option>
                            }
                        </nz-select>
                        } @else {
                        <span>{{data[col.field]}} </span>
                        }

                    </td>
                    <td *ngIf="!col?.type">
                        @if(!col.dateField){
                        @if(data?.edit && col?.editable){
                        <input [(ngModel)]="data[col.field]" class="form-control" style="width: 90%;" />
                        }
                        @else{
                        <span [innerHtml]="data[col.field] ? data[col.field] : '-'" *ngIf="!col?.dateField"></span>
                        }
                        }
                        @if(!data?.edit && col?.dateField){
                        <span *ngIf="col?.dateField">{{data[col.field] | date:"MM/dd/y, H:mm"}} </span>
                        }
                        @if(data?.edit && col?.dateField){
                        <nz-date-picker [nzAllowClear]="col?.allowClear ? true : false" nzPlaceHolder="Select date"
                            style="height: 32px;width: 100%;" [(ngModel)]="data[col.field]"
                            (ngModelChange)="formatDate(data,col,$event)" [nzShowTime]="true"></nz-date-picker>
                        }

                    </td>
                    <td *ngIf="col.showIcons">
                        <div class="d-flex">
                            @if(!data?.edit) {
                            <ng-container>
                                @for(icon of col.icons; track icon){
                                @if(icon == 'delete'){
                                <span nz-icon [nzType]="icon" class="px-2" nzTheme="outline"
                                    (click)="delete(data)"></span>
                                }
                                @else if (icon == 'edit'){
                                <span nz-icon [nzType]="icon" class="px-2" nzTheme="outline"
                                    (click)="edit(data, i)"></span>
                                }
                                }
                            </ng-container>
                            }
                            @else{
                            <ng-container>
                                <a class="px-2" style="text-decoration: none;"
                                    (click)="saveRowData(data, col.field)">Save</a>
                                <a class="px-2" style="text-decoration: none;" (click)="cancelSave(data, i)">Cancel</a>
                            </ng-container>
                            }

                        </div>
                    </td>

                </ng-container>
            </tr>
            }
        </tbody>
    </nz-table>

    <nz-table *ngIf="reOrderTable && !nestedTable" [ngStyle]="{'height':tableHeight}" #rearrangeDataTable
        [nzData]="reOrderDataSet" [nzNoResult]="'No Records Found!'" [nzShowPagination]="false"
        style="overflow-y: auto;" [nzPageSize]="reOrderDataSet.length" cdkScrollable>
        <thead>
            <tr>
                <th [ngClass]="gridStyle == 'white' ? 'grid-style' : ''"></th>
                <ng-container *ngFor="let col of columns">
                    <th *ngIf="!col?.type || col?.type == 'select'"
                        [ngStyle]="{'text-align': (col?.type== 'checkbox' && col.header) ? 'center' : 'left' }"
                        [ngClass]="gridStyle == 'white' ? 'grid-style' : ''">{{col.header}}</th>
                </ng-container>
            </tr>
        </thead>
        <tbody cdkDropList (cdkDropListDropped)="drop($event)" [cdkDropListAutoScrollStep]="10">
            @for(data of rearrangeDataTable.data; track $index; let i = $index){
            <ng-container>
                <tr cdkDrag [cdkDragData]=data class="example-custom-placeholder">
                    <td class="example-handle" cdkDragHandle><img src="reorder.png" /></td>
                    <ng-container *ngFor="let col of columns">
                        <td *ngIf="!col?.type || col?.type == 'select'">
                            <span *ngIf="!col?.dateField">{{data[col.field]}} </span>
                            @if(col?.dateField){
                            <span *ngIf="col?.dateField">{{data[col.field] | date:"MM/dd/y, H:mm"}} </span>
                            }
                        </td>
                    </ng-container>
                </tr>
            </ng-container>
            }
        </tbody>
    </nz-table>
 <nz-table *ngIf="nestedTable" #nestedTable [nzTableLayout]="'auto'" [nzShowPagination]="false"
    [nzData]="nestedParentDataSet">
    <thead>
        <tr>
            <ng-container *ngFor="let col of nestedParentColumns">
                @if(col.type === 'expand') {
                <th nzWidth="50px" style="background-color: #b3b1b1;"  ></th>
                } @else {
                <th class="fw-bolder" style="background-color: #b3b1b1;" >{{col.header}}</th>
                }
            </ng-container>
        </tr>
    </thead>
    <tbody>
        @for (parent of nestedTable.data; track parent.key) {
        <tr (click)="parent.expand = !parent.expand" style="cursor: pointer;" >
            <ng-container *ngFor="let col of nestedParentColumns">
                @if(col.type == 'expand'){
                <td nzWidth="50px" style="background-color: #d9d6d6;" [(nzExpand)]="parent.expand" (click)="$event.stopPropagation()"></td>
                } @else {
                <td class="fw-normal" style="background-color: #d9d6d6;">{{ parent[col.field] }}</td>
                }
            </ng-container>
        </tr>

        <tr [nzExpand]="parent.expand">
            <nz-table #childTable [nzData]="parent.children" [nzShowPagination]="false" [nzFrontPagination]="false"
                nzSize="middle">
                <thead>
                    <tr>
                        @for (childCol of nestedChildColumns; track childCol.field) {
                        <th class="fw-bold" style="background-color: #afacac4a;">{{ childCol.header }}</th>
                        }
                    </tr>
                </thead>
                <tbody>
                    @for (childRow of childTable.data; track childRow) {
                    <tr>
                        @for (childCol of nestedChildColumns; track childCol.field) {
                        <td class="fw-lighter">
                            {{ childRow[childCol.field] }}
                        </td>
                        }
                    </tr>
                    }
                </tbody>
            </nz-table>
        </tr>
        }
    </tbody>
</nz-table>
</div>